import React, { useEffect, useContext, useState, useCallback } from 'react'
import { Routes, Route } from "react-router-dom";
import LeftPanel from './LeftPanel';
import Navbar from './Navbar';
import "./settings.css"
import StudentProfile from "../components/Profile/StudentProfile";
import { fetchUserProfileData } from '../services';
import { MyContext } from '..';
import Account from '../components/User/Account';
import NewOrganizations from '../components/User/NewOrganizations';
import Subscriber from '../components/User/Subscriber';
import Users from '../pages/Users';
import PublicProfile from '../pages/PublicProfile';
// import Profile from '../components/Profile/Profile';

export default function Settings(props) {
    const queryParameters = new URLSearchParams(window.location.search)
    const username = queryParameters.get("username") || props.username
    const subscriberCode = queryParameters.get("subcode") || props.subCode
    const [organizationCode, setOrganizationCode] = useState(queryParameters.get("orgcode") || props.orgCode)
    const role = queryParameters.get("role") || props.role
    const { backendUrl } = useContext(MyContext);
    const [userData, setUserData] = useState({})
    const fetchData = useCallback(async () => {
        try {
            const res = await fetchUserProfileData(backendUrl, username, subscriberCode);
            setUserData({
                username: res.data.user.username,
                fullName: res.data.user.full_name,
                email: res.data.user.email
            })
            setOrganizationCode(res.data.user.organization_code)
        } catch (error) {
            console.log(error);
        }
    }, [backendUrl, subscriberCode, username])
    useEffect(() => {
        // Fetch student data when the component mounts
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchData]);
    return (
        <div className='settings-body p-2'>
            <Navbar id="navbar" userData={userData} />
            <LeftPanel id="leftpanel" orgCode={organizationCode}/>
            <div className="midpanel" id='midpanel'>
                <Routes path="/">
                    <Route path="" element={<StudentProfile title="Profile | Settings" username={userData.username} role={role} orgCode={organizationCode} subCode={subscriberCode} />} />
                    <Route path="profile" element={<StudentProfile title="Profile | Settings" username={userData.username} role={role} orgCode={organizationCode} subCode={subscriberCode} />} />
                    <Route path="public-profile" element={<PublicProfile title="Public | Profile" username={userData.username} role={role} orgCode={organizationCode}/>} />
                    <Route path="account" element={<Account title="Account | Settings" userData={userData} role={role}/>} />
                    <Route path="organizations" element={<Subscriber title="Organizations | User" userData={userData}/>} />
                    <Route path="neworganization" element={<NewOrganizations title="Create | Organization" userData={userData} orgCode={organizationCode} subCode={subscriberCode}/>} />
                    <Route path="users" element={<Users title="Users | Settings" orgCode={organizationCode} subCode={subscriberCode} username={username} role={role} />} />
                </Routes>
            </div>
        </div>
    )
}
